import React from "react";

import { Header } from "../../components/Header";
import { SolutionBuildIdaasBanner } from "../../blocks/solution-build-idaas-banner";

import { useTranslation } from "react-i18next";
import "./styles.less";
import { AdModal } from "../../blocks/solution-build-ad-modal";
import { AdContent } from "../../blocks/solution-build-ad-content";
import { Footer } from "../../components/FooterV2";
import { Notice } from "../../components/Notice";
import { tryNow } from "../../utils";
import { CommonConsult } from "../../blocks/common-consult";
// import { CommonLinkPage } from "../../blocks/common-link-page";
import { HomeTryOn } from "../../blocks/home-try-on";

export const BuildADPage = () => {
  const { t } = useTranslation();

  return (
    <div className="ad-page">
      <Header mode="light" />
      <SolutionBuildIdaasBanner
        title={t("solution.buildAd.banner.title")}
        subtitle={t("solution.buildAd.banner.subtitle")}
        subtitle2={t("solution.buildAd.banner.subtitle2")}
        imgurl="//files.authing.co/authing-website/solution-scene-banner.svg"
      />
      <AdContent />
      <AdModal />
      {/* <CommonLinkPage pagesLink={pagesLink} /> */}
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
